import { render, staticRenderFns } from "./UnauthorisedClient.vue?vue&type=template&id=3a8143c8"
import script from "./UnauthorisedClient.vue?vue&type=script&lang=js"
export * from "./UnauthorisedClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports